// Partner / influencer attribution. `?ref=code` is remembered for 30 days (localStorage)
// so a visitor who comes back later still credits the creator who sent them.
const KEY = "hv_ref";
const TTL = 30 * 24 * 60 * 60 * 1000;
const API = process.env.REACT_APP_BACKEND_URL;

export const captureRef = async () => {
  const code = (new URLSearchParams(window.location.search).get("ref") || "").toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 24);
  if (!code) return;
  try {
    const r = await fetch(`${API}/api/partners/check/${code}`);
    const { valid } = await r.json();
    if (valid) localStorage.setItem(KEY, JSON.stringify({ code, exp: Date.now() + TTL }));
  } catch {
    /* ignore */
  }
};

export const getRef = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    if (v && v.exp > Date.now()) return v.code;
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  return "";
};
